import { TableCellPerColumn } from "ds/components/TableSimple/types";

import { MODULE_VERSION_CONSUMERS_COLUMN_ID } from "../constants";
import { ModuleVersionConsumerRow } from "../types";
import ModuleVersionConsumersTableNameCell from "./NameCell";
import ModuleVersionConsumersTableSpaceCell from "./SpaceCell";

export const MODULE_VERSION_CONSUMERS_TABLE_CELLS: TableCellPerColumn<ModuleVersionConsumerRow> = {
  [MODULE_VERSION_CONSUMERS_COLUMN_ID.NAME]: ModuleVersionConsumersTableNameCell,
  [MODULE_VERSION_CONSUMERS_COLUMN_ID.SPACE]: ModuleVersionConsumersTableSpaceCell,
};
